import React from 'react';
import classnames from 'classnames';
import { Animate } from '../../../animate/animate';
import styles from './actions-panel.scss';
export const InfoOverlayAnimate = ({ type = 'fade-in-out', when, children, }) => (React.createElement(Animate, { type: type, className: styles['info-overlay'], when: when }, children));
export const InfoOverlayWrapper = ({ isActive = false, className, dir, children, }) => (React.createElement("div", { className: classnames(styles['info-overlay-wrapper'], {
        [styles.active]: isActive,
    }, className), dir: dir }, children));
//# sourceMappingURL=info-overlay.js.map